import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query AbsenceReasons {
  absenceReasons {
    id
    message
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

function getAbsenceReasons() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((data) => data.data.absenceReasons);
}

export default getAbsenceReasons;
